import { useLanguage } from "../../../../contexts/LanguageContext"
import StepBubble from "./StepBubble"
import StepActions from "./StepActions"
import StepArrow from "./StepArrow"
import HighlightInputDemo from "../main-popup/HighlightLabel"

/**
 * Main step-by-step preview component.
 * Orchestrates the complete step-by-step interface by combining bubble content, actions, and arrow.
 * @param {Object} props
 * @param {Object} props.parameters - Configuration parameters
 * @returns {JSX.Element}
 */
export default function PreviewStep({ parameters }) {
  const { t } = useLanguage()

  return (
    <div>
      <div className="preview_headerBloc">{t("Sbs.sbsTitle")}</div>
      <div id="preview_step" className="shortways-hopscotch hopscotch-bubble animated">
        <div className="hopscotch-bubble-container" style={{ width: "300px" }}>
          <StepBubble parameters={parameters} />
          <StepActions parameters={parameters} />
          <StepArrow />
        </div>
      </div>
      <HighlightInputDemo color={parameters.modalHighlightColor || "#FFD600"} />
    </div>
  )
}
